__turbopack_context__.v({
  "icon": "PasswordInput-module-scss-module__RDtJJa__icon",
  "inputWrapper": "PasswordInput-module-scss-module__RDtJJa__inputWrapper",
});
